import { getOrderHistory } from "../../api/user";
import { useState, useEffect } from "react";
import { Order as OrderObject, OrderItem } from "../../classes/Order";
import { ImageDiv } from "../../helper/image";
import '../../styles/style.css';

const OrderHistoryComponent = ({ user, items }) => {
    const [orders, setOrders] = useState(new Map());
    const [order, setOrder] = useState(null);

    useEffect(() => {
        async function fetchOrders() {
            const userDetails = await getOrderHistory();
            if (userDetails) {
                const newOrders = new Map();
                for (const [key, value] of Object.entries(userDetails)) {
                    const transaction = value['transaction'];
                    const items = value['items'];
                    const itemsList = [];
                    for (const i of items) {
                        const item = new OrderItem(i['product_id'], i['transaction_id'], i['quantity'], i['sold_price']);
                        itemsList.push(item);
                    }
                    console.log([transaction['id'], [transaction, itemsList]]);
                    newOrders.set(transaction['id'], [transaction, itemsList]);
                }
                setOrders(newOrders); // Set the orders Map here
            }
        }
        fetchOrders();
    }, []); // Runs once on component mount

    function getProductToItem(item_id) {
        // Assuming 'products' is an array of product objects with an 'id' field
        const product = items.find(product => product.id === item_id); // Use `find` to get the first matching product
        console.log(product);
        return product;  // Assuming you want the name, or you can adjust to return any other field
    }

    const Orders = () => {
        return (
            <div>
                <h1>Orders</h1>
                <div className="column">
                    {Array.from(orders).sort().reverse().map(([key, order]) => (
                        <button className="padding-bottom" onClick={() => setOrder(order)} key={key}>
                            <h2>#{order[0].id} | {formatDate(order[0].created_at)} | {order[0].shipped ? 'Shipped!' : 'Not Shipped'}</h2>
                        </button>
                    ))}
                </div>
            </div>
        );
    };

    const Order = () => {
        return (
            <div>
                <div className="row column">
                    <button onClick={() => setOrder(null)}>
                        <h1>{'<-'} Order #{order[0].id}</h1>
                    </button>
                    {order[0].shipped ? 
                    <a href={`https://auspost.com.au/mypost/track/details/${order[0].track_number}`}> Tracking: {order[0].track_number}</a> : "Not Yet Shipped"}
                    <div>{order[0].shipping_paid ? "Shipping paid" : "Shipping not paid"}</div>
                </div>
                <div className="cart-item">
                        <h2>Image</h2>
                        <h2>Item</h2>
                        <h2>Price</h2>
                        <h2>Quantity</h2>
                    </div>
                {order[1].map((item) => (
                    <div className="cart-item">
                        <ImageDiv itemName={getProductToItem(item.id).name} type={getProductToItem(item.id).type} imageSrc={getProductToItem(item.id).imageUrl}/>
                        <h2>{getProductToItem(item.id).name}</h2>
                        <h2>${(item.sold_price).toFixed(2)}</h2>
                        <h2>{item.quantity}</h2>
                    </div>
                    ))}
            </div>
        );
    };

    return (
        <div id="menu-container">
            {order === null ? <Orders /> : <Order />}
        </div>
    );
};

function formatDate(isoString) {
    const date = new Date(isoString);

    // Format the date and time in AEDT
    const options = {
        timeZone: "Australia/Sydney",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    };

    const formatter = new Intl.DateTimeFormat("en-US", options);
    const formattedDate = formatter.format(date);

    // Adjust the output format
    return formattedDate.replace(',', '');
}

export default OrderHistoryComponent;
